'use client';

import { Button } from '@coolblue-development/freddy';
import shareWishlistTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/shareWishlistTrigger';
import { Share } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import ShareWishlistModal from '@features/wishlist/components/ShareWishlist/ShareWishlistModal';
import { useTranslation } from '@i18n/useTranslation';
import { ReactNode, useState } from 'react';

export default function ShareWishlistButton({
  shareableWishlistUrl
}: {
  shareableWishlistUrl: string;
}): ReactNode {
  const { t } = useTranslation('webshop.wishlist');
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const { trackEvent } = useAnalytics();

  return (
    <>
      <ShareWishlistModal
        isOpen={isShareModalOpen}
        setIsOpen={setIsShareModalOpen}
        shareableWishlistUrl={shareableWishlistUrl}
      />
      <Button
        variant='secondary'
        startIcon={<Share />}
        order={{ xs: 1, md: 2 }}
        fullWidthUntil='md'
        onClick={() => {
          setIsShareModalOpen(true);
          trackEvent(shareWishlistTrigger({ content: 'share' }));
        }}
      >
        {t('shareWishlist')}
      </Button>
    </>
  );
}
